import React from "react";
import data1 from "../../images/lines.svg";
import tut from "../../images/tutorials.svg";
import swift from "../../images/swift-logo.png";
import file from "../../images/file.svg";
import code from "../../images/code.svg";
import axios from "axios";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

export default function Tutorial() {
  const navigate = useNavigate();
  return (
    <div>
      {/* <div className="lazyload-wrapper">
        <div className=" t1">
          <div className="t2">
            <div className="lazyload-wrapper">
              <div className="t3">
                <div className="t4">
                  <svg
                    width="1440"
                    height="699"
                    viewBox="0 0 1440 699"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <defs>
                      <clipPath id="wave1">
                        <path
                          d="M779 21C682.673 -34.6485 598 40.7563 508 21.0002C418 1.24407 348 58.0011 220 36.0005C92 14 17 29.0005 9.99191e-08 44.9611C9.98018e-08 131.031 1.2729e-06 571.443 1.2729e-06 571.443L1611.5 571.443L1611.5 55C1611.5 55 1484 55.0005 1417 36.0005C1350 17.0005 1323.29 56.1967 1117 36.0005C910.71 15.8043 828.959 49.8618 779 21Z"
                          fill="url(#paint0_linear)"
                        ></path>
                      </clipPath>
                    </defs>
                  </svg>
                </div>
                <div className="t5">
                  <svg
                    width="1440"
                    height="699"
                    viewBox="0 0 1440 699"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <defs>
                      <clipPath id="wave2">
                        <path
                          d="M1075 35.4323C1018.5 27.904 972.769 61.8428 910 26.9318C831.581 -16.6829 790.5 6.93181 669 6.93181C547.5 6.93181 484.744 59.6603 398.5 26.9319C328.97 0.546542 314 74 181.5 54C49 34 0.258789 34 0.258789 34C0.258789 120.822 0.25879 377.5 0.25879 377.5L1504.12 377.5L1504.12 69.4323C1504.12 69.4323 1335.5 77.4323 1278 69.4323C1220.5 61.4323 1203.09 87.6455 1167.5 69.4323C1126.21 48.2999 1131.5 42.9607 1075 35.4323Z"
                          fill="url(#paint0_linear)"
                        ></path>
                      </clipPath>
                    </defs>
                  </svg>
                </div>
                <div className="t6">
                  <svg
                    width="1440"
                    height="699"
                    viewBox="0 0 1440 699"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <defs>
                      <clipPath id="wave3">
                        <path
                          d="M1043 16C986.5 8.47162 971.769 70.9109 909 35.9999C830.581 -7.61479 789.5 16 668 16C546.5 16 483.744 68.7285 397.5 36.0001C327.97 9.61469 283 55.9999 181.5 15.9999C80 -24.0001 0.258789 25.9999 0.258789 25.9999C0.258789 112.822 0.25879 339.5 0.25879 339.5L1504.12 339.5L1504.12 25.9999C1504.12 25.9999 1324.5 23.9999 1267 15.9999C1209.5 7.99991 1192.09 34.2131 1156.5 15.9999C1115.21 -5.1325 1099.5 23.5284 1043 16Z"
                          fill="url(#paint0_linear)"
                        ></path>
                      </clipPath>
                    </defs>
                  </svg>
                </div>
                <div
                  style={{ backgroundImage: `url(${data1})` }}
                  className="t7"
                ></div>
              </div>
            </div>
          </div>
          <div className="t8">
            <div className=" t9">
              <p className="t10">Premium tutorials </p>
              <h2 className='tt"'>Tutorials to guide you beyond</h2>
              <p className="tt1">
                Once you’ve completed the courses, learn from our quick design
                and code tutorials to strengthen your knowledge
              </p>
              <a className="a1" href="/tutorials">
                <button className="b1">
                  <img alt="" src={tut} className="b2 " />
                  <p className="b3">More tutorials</p>
                </button>
              </a>
            </div>
            <div className="b4">
              <a className="a2">
                <div className="tt2">
                  <div className="tt3">
                    <div className="lazyload-wrapper">
                      <img alt="" src={swift} className="tt4" />
                    </div>
                    <div className="tt5">
                      <p className="tt6"></p>
                      <h3 className="tt7">
                        SwiftUI <br /> Handbook
                      </h3>
                      <p className="tt8">
                        A comprehensive series of tutorials covering Xcode,
                        SwiftUI and all the layout and development techniques
                      </p>
                      <div className="tt9">
                        <div className="ttt">
                          <img alt="" src={file} className="ff" />
                        </div>
                        <p className="f"> 98 free tutorials </p>
                      </div>
                      <div className="tt9">
                        <div className="ttt">
                          <img alt="" src={code} className="ff" />
                        </div>
                        <p className="f"> Videos, PDF, files</p>
                      </div>
                    </div>
                  </div>
                  <div
                    color="linear-gradient(180deg, #408DD5 0%, #630B8C 100%)"
                    className=" c"
                  ></div>
                </div>
              </a>
              <a className="a2">
                <div className="tt2">
                  <div className="tt3">
                    <div className="lazyload-wrapper">
                      <img alt="" src={swift} className="tt4" />
                    </div>
                    <div className="tt5">
                      <p className="tt6"></p>
                      <h3 className="tt7">
                        SwiftUI <br /> Handbook
                      </h3>
                      <p className="tt8">
                        A comprehensive series of tutorials covering Xcode,
                        SwiftUI and all the layout and development techniques
                      </p>
                      <div className="tt9">
                        <div className="ttt">
                          <img alt="" src={file} className="ff" />
                        </div>
                        <p className="f"> 98 free tutorials </p>
                      </div>
                      <div className="tt9">
                        <div className="ttt">
                          <img alt="" src={code} className="ff" />
                        </div>
                        <p className="f"> Videos, PDF, files</p>
                      </div>
                    </div>
                  </div>
                  <div
                    color="linear-gradient(180deg, #C03495 0%, #4C24D6 100%)"
                    className="cc"
                  ></div>
                </div>
              </a>
            </div>
          </div>
        </div>
      </div> */}

      <div className="lazyload-wrapper">
        <div className=" t1">
          <div className="t2">
            <div className="lazyload-wrapper">
              <div className="t3">
                <div className="t4">
                  <svg
                    width="1440"
                    height="699"
                    viewBox="0 0 1440 699"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <defs>
                      <clipPath id="wave1">
                        <path
                          d="M779 21C682.673 -34.6485 598 40.7563 508 21.0002C418 1.24407 348 58.0011 220 36.0005C92 14 17 29.0005 9.99191e-08 44.9611C9.98018e-08 131.031 1.2729e-06 571.443 1.2729e-06 571.443L1611.5 571.443L1611.5 55C1611.5 55 1484 55.0005 1417 36.0005C1350 17.0005 1323.29 56.1967 1117 36.0005C910.71 15.8043 828.959 49.8618 779 21Z"
                          fill="url(#paint0_linear)"
                        ></path>
                      </clipPath>
                    </defs>
                  </svg>
                </div>
                <div className="t5">
                  <svg
                    width="1440"
                    height="699"
                    viewBox="0 0 1440 699"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <defs>
                      <clipPath id="wave2">
                        <path
                          d="M1075 35.4323C1018.5 27.904 972.769 61.8428 910 26.9318C831.581 -16.6829 790.5 6.93181 669 6.93181C547.5 6.93181 484.744 59.6603 398.5 26.9319C328.97 0.546542 314 74 181.5 54C49 34 0.258789 34 0.258789 34C0.258789 120.822 0.25879 377.5 0.25879 377.5L1504.12 377.5L1504.12 69.4323C1504.12 69.4323 1335.5 77.4323 1278 69.4323C1220.5 61.4323 1203.09 87.6455 1167.5 69.4323C1126.21 48.2999 1131.5 42.9607 1075 35.4323Z"
                          fill="url(#paint0_linear)"
                        ></path>
                      </clipPath>
                    </defs>
                  </svg>
                </div>
                <div className="t6">
                  <svg
                    width="1440"
                    height="699"
                    viewBox="0 0 1440 699"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <defs>
                      <clipPath id="wave3">
                        <path
                          d="M1043 16C986.5 8.47162 971.769 70.9109 909 35.9999C830.581 -7.61479 789.5 16 668 16C546.5 16 483.744 68.7285 397.5 36.0001C327.97 9.61469 283 55.9999 181.5 15.9999C80 -24.0001 0.258789 25.9999 0.258789 25.9999C0.258789 112.822 0.25879 339.5 0.25879 339.5L1504.12 339.5L1504.12 25.9999C1504.12 25.9999 1324.5 23.9999 1267 15.9999C1209.5 7.99991 1192.09 34.2131 1156.5 15.9999C1115.21 -5.1325 1099.5 23.5284 1043 16Z"
                          fill="url(#paint0_linear)"
                        ></path>
                      </clipPath>
                    </defs>
                  </svg>
                </div>
                {/* <div
                  style={{ backgroundImage: `url(${data1})` }}
                  className="t7"
                ></div> */}
              </div>
            </div>
          </div>
          <div className="t8">
            <div className=" t9">
              <p className="t10">Premium Plan </p>
              <h2 className='tt"'>Emails</h2>
              <p className="tt1">
              Basic
Security

Better Security

Friendly

Environmental Friendly

Manageable

Remotely Manageable

sharing

Easy sharing

saving

Time-saving

Effective

Cost-Effective
              </p>
              <span className="a1">
                <button className="b1"
                 onClick={() =>{localStorage.getItem("token")?(navigate("/profile")):toast("! Please login ")}}>
                
                  <img alt="" src={tut} className="b2 " />
                  <p className="b3">More Plan</p>
                </button>
              </span>
            </div>
            <div className="b4">
              <span className="a2">
                <div className="tt2">
                  <div className="tt3">
                    <div className="lazyload-wrapper">
                      <img alt="" src={swift} className="tt4" />
                    </div>
                    <div className="tt5">
                      <p className="tt6"></p>
                      <h3 className="tt7">
                   Private     Email  <br /> Server
                      </h3>
                      <p className="tt8">
                      Individual Basic
domain

Email that matches your domain.

Email

Mobile-friendly webmail.
                      </p>
                      <div className="tt9">
                        <div className="ttt">
                          <img alt="" src={file} className="ff" />
                        </div>
                        <p className="f"> 12 Months Plan</p>
                      </div>
                      <div className="tt9">
                        <div className="ttt">
                          <img alt="" src={code} className="ff" />
                        </div>
                        <p className="f">  Monthly , Yearly  </p>
                      </div>
                    </div>
                  </div>
                  <div
                    color="linear-gradient(180deg, #408DD5 0%, #630B8C 100%)"
                    className=" c"
                  ></div>
                </div>
              </span>
              <span className="a2">
                <div className="tt2">
                  <div className="tt3">
                    <div className="lazyload-wrapper">
                      <img alt="" src={swift} className="tt4" />
                    </div>
                    <div className="tt5">
                      <p className="tt6"></p>
                      <h3 className="tt7">
                      Gsuite & Hotmail 
                      </h3>
                      <p className="tt8">
                      Basic
Security

Better Security

Friendly

Environmental Friendly

Manageable

Remotely Manageable

sharing

Easy sharing

saving

Time-saving

Effective

Cost-Effective
                      </p>
                      <div className="tt9">
                        <div className="ttt">
                          <img alt="" src={file} className="ff" />
                        </div>
                        <p className="f"> 12 Months Plan </p>
                      </div>
                      <div className="tt9">
                        <div className="ttt">
                          <img alt="" src={code} className="ff" />
                        </div>
                        <p className="f">   Monthly , Yearly </p>
                      </div>
                    </div>
                  </div>
                  <div
                    color="linear-gradient(180deg, #C03495 0%, #4C24D6 100%)"
                    className="cc"
                  ></div>
                </div>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
